import {
  CO_GET_SUPPLIERNAME_LISTING,
  CO_GET_SUPPLIERNAME_LISTING_SUCCESS,
  CO_GET_SUPPLIERNAME_LISTING_FAILED,
  } from "./actionTypes"
  
  export const coSupplierNameListing = () => {
    return {
      type: CO_GET_SUPPLIERNAME_LISTING,
    }
  }
  
  export const coSupplierNameListingSuccess = supplierName => {
    return {
      type: CO_GET_SUPPLIERNAME_LISTING_SUCCESS,
      payload: supplierName,
    }
  }
  
  export const coSupplierNameListingFail = error => {
    return {
      type: CO_GET_SUPPLIERNAME_LISTING_FAILED,
      payload: error,
    }
  }
  